import { AppBar, Dialog, IconButton, Paper, Slide, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import React from 'react';
import DividasEmAbertoApi from '../../api/DividasEmAbertoApi';
import { withLoading } from '../../contexts/LoadingContext';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import PrintComponentDividasEmAberto from './PrintComponentDividasEmAberto';
import { format, isAfter, subMonths, isEqual } from 'date-fns';
import TipoSituacaoServidorApi from '../../api/TipoSituacaoServidorApi';
import Utils from '../share/Utils';

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  toolbar: {
    display: 'flex',
    backgroundColor: '#5c6bc0',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: theme.spacing(2),
  },
  flex: {
    flex: 1,
  },
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(15),
    margin: theme.spacing(2),
  },
});

function Transition (props) {
  return <Slide direction='left' {...props} />;
}
class FullScreenDividasEmAbertoPorPeriodoPrint extends React.Component {
  dividasEmAbertoApi = new DividasEmAbertoApi();
  tiposDeSituacaoApi = new TipoSituacaoServidorApi();
  utils = new Utils();
  state = {
    dividasEmAbertoResultado: [],
    tiposSituacao: [],
    loading: true,
  }
  componentDidMount = async () => {
    this.props.showLoading('Aguarde, essa consulta pode demorar um pouco..');

    await this.consultarTiposSituacao();

    let codigosSituacao = [];
    for (var i = 0; i < this.state.tiposSituacao.length; i++){
      codigosSituacao.push(this.state.tiposSituacao[i].id)
    }

    let anoFrom = Number(this.props.mesAnoFrom.substring(3, 7));
    let mesFrom = Number(this.props.mesAnoFrom.substring(0, 2));
    let dataFrom = new Date(anoFrom, mesFrom, 1);

    let anoTo = Number(this.props.mesAnoTo.substring(3, 7));
    let mesTo = Number(this.props.mesAnoTo.substring(0, 2));
    let dataTo = new Date(anoTo, mesTo, 1);

    dataFrom = subMonths(dataFrom, 1);
    dataTo = subMonths(dataTo, 1);

    let resultado = [];

    while (isAfter(dataTo, dataFrom) || isEqual(dataTo, dataFrom)) {
      let registro = format(new Date(dataTo), 'MM/YYYY');
      resultado.push(registro);
      dataTo = subMonths(dataTo, 1);      
    }

    let dividasEmAbertoResultado = [];

    for (var i = 0; i < resultado.length; i++){
      var filter = {
        ano: Number(resultado[i].substring(3, 7)),
        mes: Number(resultado[i].substring(0, 2)),
        codServidor: this.props.codServidor,
        nomeServidor: this.props.nomeServidor,
        resumido: false,
        situacoesServidor: codigosSituacao,
        indTodos: 'T'
      };

      let dividasEmAberto = await this.dividasEmAbertoApi.consultarDividasEmAberto(filter);
      if (dividasEmAberto[0] === undefined){
        let situacao = await this.dividasEmAbertoApi.getSituacao(this.props.codServidor);
        let regBranco = {
          dataRef : this.utils.zeroPad(filter.mes, 2) + "/" + filter.ano,
          beneficiario : this.props.codServidor + ' - ' + this.props.nomeServidor,
          situacaoAtual : situacao,
          nome : this.props.nomeServidor,
          saldoAnteriorDivida : 0,
          valorDividaMes : 0,
          valorPagamentoMes : 0,
          perdasPorFalecimento : 0,
          perdasPorPequenoValor : 0,
          dividaEmAberto : 0,
          txtObservacao: '',
        };
        dividasEmAbertoResultado.push(regBranco)
      } else {
        dividasEmAbertoResultado.push(dividasEmAberto[0])
      }      
    }

    this.setState({ loading: false, dividasEmAbertoResultado: dividasEmAbertoResultado });
    this.props.hideLoading();
  }

  consultarTiposSituacao = async () => {
    const tiposSituacao = await this.tiposDeSituacaoApi.consultarTiposSituacao();
    this.setState({tiposSituacao: tiposSituacao});
  }
  render () {
    const { classes, open, handleClose } = this.props;
    return (
      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          scroll='paper'
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Paper square elevation={0} className={classes.toolbar} onClick={handleClose} color='inherit'>
              <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h6' color='inherit' className={classes.flex}>
                {'Relatório de Dívidas em Aberto - Mês de Referência: ' + this.props.mesAnoFrom + ' a ' + this.props.mesAnoTo} {' - Consolidado '}
              </Typography>
            </Paper>
          </AppBar>
          {this.state.loading ? <LinearProgressBlockScreen />
            : <PrintComponentDividasEmAberto
              dividasEmAberto={this.state.dividasEmAbertoResultado}
              dataRef={this.props.mesAnoFrom}
              dataFim={this.props.mesAnoTo}
              resumido={false}
              porPeriodo={true}
               />}
        </Dialog>
      </div>
    );
  }
}

export default withLoading(withStyles(styles)(FullScreenDividasEmAbertoPorPeriodoPrint));
